import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IconsModule } from "../icons/icons.module";
import { FooterComponent } from "./footer.component";

@NgModule({
  imports: [CommonModule, IconsModule, RouterModule],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class FooterComponentModule { }
